import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import creditCards from "~@/assets/image/non-svg/credit-cards.png";
import { useGetLinkToAddCardQuery } from "~@/graphql/codegen/generated";
import { sanitize } from "~@/utils";

const Add: FC = () => {
  const { t } = useTranslation();

  const { data: linkToAddCardData } = useGetLinkToAddCardQuery({
    variables: {
      successUrl: "/",
    },
  });

  const link = useMemo(() => {
    return linkToAddCardData?.getLinkToAddCard;
  }, [linkToAddCardData]);

  return (
    <>
      <div className="block block--has-mb-14">
        <figure className="image image--is-auto">
          <img src={creditCards} alt="cards icon" />
        </figure>
      </div>
      <div className="block block--has-mb-30">
        <p className="onboarding__text">
          {sanitize({ html: t("onboarding.payment-method.description") })}
        </p>
      </div>
      <div className="block">
        <a href={link}>
          <button
            className="button button--h-48 button--fill-black-0"
            type="button"
          >
            <span>{t("action.add-payment-method")}</span>
          </button>
        </a>
      </div>
    </>
  );
};

export default Add;
